import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'sio',
        loadChildren: () => import('./sio/sio.module').then(m => m.SioModule)
      },
      {
        path: 'jpo',
        loadChildren: () => import('./jpo/jpo.module').then(m => m.JpoModule)
      },
      {
        path: 'student',
        loadChildren: () => import('./student/student.module').then(m => m.StudentModule)
      },
      {
        path: 'entreprise',
        loadChildren: () => import('./entreprise/entreprise.module').then(m => m.EntrepriseModule)
      },
      {
        path: 'suivis',
        loadChildren: () => import('./suivis/suivis.module').then(m => m.SuivisModule)
      },
      {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
      },      
      {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
      },
    ])
  ]
})
export class PageModule {}
